import React from "react"
import PropTypes from "prop-types"
import {observer} from "mobx-react"
import EntreeStore from "./EntreeStore"
import Dashboard from "./Entree/Dashboard"
import Audios from "./Entree/Audios"
import ExpertiseEntree from "./Entree/ExpertiseEntree"
import Takepicture from "./Entree/Takepicture"
import Gestion from "./Gestion/Gestion"
import SignEntree from "./Signatures/SignEntree"
import RemarquesLiminaires from "./Liminaires/RemarquesLiminaires"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import {Redirect } from "react-router-dom";
import 'moment/locale/fr';
@observer
class Routeur extends React.Component {
  constructor(props) {
    super(props);
    EntreeStore.bien = props.bien
    EntreeStore.ordremission = props.ordremission
    EntreeStore.entree = props.entree
    EntreeStore.rdv = props.rdv
    this.redirects = this.redirects.bind(this)
    let redirect = ""
    this.state= {
      redirect: redirect
    }

  }
  redirects(){
    if(this.state.redirect.length >1){
      return(<Redirect to={this.state.redirect} />)
    }else{
      return(<div></div>)
    }
  }


  render () {
    if(EntreeStore.loaded){
      return (
        <React.Fragment>
         <Router>
          <div>
          <div className="row">
            <div className="col s2"><Link to="/"> Liminaires</Link></div>
            <div className="col s2"><Link to="/Dashboard"> Etat des lieux</Link></div>
            <div className="col s2"><Link to="/expertise/signature"> Signer</Link></div>
            <div className="col s2"><Link to="/expertise/gestion"> Gestion</Link></div>
            <div className="col s2">
              <div className="switch">
                <label>
                  Tablette
                  <input type="checkbox"  defaultChecked={EntreeStore.modepc} onChange={(e) =>EntreeStore.modepc = !EntreeStore.modepc}/>
                  <span className="lever"></span>
                  PC
                </label>
              </div>
            </div>
          </div>
            <Route path="/" exact component={RemarquesLiminaires} />
            <Route path="/Dashboard" exact component={Dashboard} />
            <Route path="/expertise/piece/:pieceid/:title" component={ExpertiseEntree} />
            <Route path="/expertise/photo/:pieceid/:expertiseid" component={Takepicture} />
            <Route path="/expertise/audio/:pieceid/:expertiseid" component={Audios} />
            <Route path="/expertise/signature" component={SignEntree} />
            <Route path="/expertise/Gestion" component={Gestion} />
          </div>
        {this.redirects()}
        </Router>
        </React.Fragment>
      );
    }else{
      return(
        <React.Fragment>
        <p>Chargement en cours</p>
        </React.Fragment>
        )
    }
  }
}

export default Routeur
